<template>
  <CookieLaw theme="dark-lime" class="cookie-wrap">
    <template v-slot:default="props">
      <div>
        <div>
          {{ $t('cookie1') }}
          <RouterLink to="/confidential">
            {{ $t('cookie1Link') }}
          </RouterLink>
        </div>
        <div>
          {{ $t('cookie2') }}
          <RouterLink to="/donotsell">
            {{ $t('cookie2Link') }}
          </RouterLink>
        </div>
        <div>
          {{ $t('cookie3') }}
          <RouterLink to="/confidential">
            {{ $t('cookie3Link') }}
          </RouterLink>
        </div>
        <br>
        <VBtn data-cy="cookieAccept" class="cookie-btn mr-2" @click="load(props.accept)">
          {{ $t('accept') }}
        </VBtn>
        <VBtn height="40px" outlined color="white" class="cookie-btn" @click="props.close">
          {{ $t('reject') }}
        </VBtn>
      </div>
    </template>
  </CookieLaw>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import useTrackers from '@/compositions/useTrackers';

export default {
  name: 'AppCookieLaw',
  components: { CookieLaw },
  setup() {
    const { loadGtm } = useTrackers();

    loadGtm();

    function load(close) {
      close();
    }

    return {
      load,
    };
  },
};
</script>

<style lang="scss" scoped>
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .cookie-wrap {
    font-size: 0.875rem;
  }
}
</style>

<i18n locale="en" lang="yaml">
cookie1: We and selected partners use cookies or similar technologies as specified in the
cookie1Link: cookie policy
cookie2: In case of dissemination of your personal information, you may opt out by using the link
cookie2Link: Do Not Sell My Personal Information
cookie3: To find out more about the categories of personal information collected and the purposes
 for which such information will be used, please refer to our
cookie3Link: privacy policy
reject: Reject
accept: Accept
</i18n>

<i18n locale="ru" lang="yaml">
cookie1: Мы и некоторые партнеры используем файлы cookie или аналогичные технологии, как указано в
cookie1Link: политике использования файлов cookie
cookie2: В случае распространения вашей личной информации вы можете отказаться, используя ссылку
cookie2Link: не распространять мою личную информацию
cookie3: "Чтобы узнать больше о категориях собираемой личной информации и целях,
 для которых такая информация будет использоваться, пожалуйста, обратитесь к нашей"
cookie3Link: политике конфиденциальности
reject: Отклонить
accept: Принять
</i18n>
